var $ = require('../../modules/$');
require('../../modules/es6.object.get-own-property-names');
module.exports = function getOwnPropertyNames(it){
  return $.getNames(it);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/object/get-own-property-names.js
 ** module id = 323
 ** module chunks = 1
 **/